export type SyncTask = () => void
export type AsyncTask = () => Promise<void>

export function safeAnyIgnoringPromise<T extends (...args: never[]) => void | Promise<void>>(unsafeFunction: T) {
  return (...args: Parameters<T>): void => {
    try {
      const result = unsafeFunction(...args)
      if (result && typeof result.then === 'function') {
        result.catch(() => {
          // Ignores async error
        })
      }
    } catch {
      // Ignores Error
    }
  }
}

export function safeSync<T extends (...args: never[]) => void>(unsafeFunction: T) {
  return (...args: Parameters<T>): void => {
    try {
      unsafeFunction(...args)
    } catch {
      // Ignores Error
    }
  }
}

export function safeAsync<T extends (...args: never[]) => Promise<void>>(unsafeFunction: T) {
  return async (...args: Parameters<T>): Promise<void> => {
    try {
      await unsafeFunction(...args)
    } catch {
      // Ignores Error
    }
  }
}
